import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useViewport } from '@chilecompra/react-kit'
import { Typography } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import { BoldText, Card, Content, GridContainer, GridItem, Image, Root } from './HomeBuyerList.styles'

/**
 * The HomeBuyerList's container.
 */
const HomeBuyerList = () => {
  const { cumulativeAmountYear } = useSelector(state => state.homeTradedAmounts)
  const { size } = useViewport()
  const navigate = useNavigate()
  const handleGoTo = useCallback(route => () => navigate(route), [])

  return (
    <Root>
      <Content>
        <GridContainer>
          <GridItem xs={12} md={6}>
            <Typography
              color="primary"
              fontSize="18px"
              fontWeight="bold"
              lineHeight="21px"
              margin={size.isUpToMedium ? '96px 0 0' : '24px 0'}
              variant="body1"
            >
              Compradores del Estado
            </Typography>
            <Typography
              fontSize="34px"
              fontWeight="bold"
              lineHeight="38px"
              margin={size.isUpToMedium ? '12px 0' : '0'}
              variant="h2"
              width={size.isUpToMedium ? '485px' : undefined}
            >
              Listado de todos los organismos compradores
            </Typography>
            <Typography
              fontSize="18px"
              lineHeight="24px"
              margin={size.isUpToMedium ? '0' : '24px 0'}
              variant="body1"
              width={size.isUpToMedium ? '448px' : undefined}
            >
              Los siguientes <BoldText>{cumulativeAmountYear?.qtyOrganismAnnual}</BoldText> compradores corresponden a
              todos aquellos que hayan emitido una orden de compra o publicado alguna licitación en Mercado Público
              desde el año {cumulativeAmountYear?.year} en adelante.
            </Typography>
          </GridItem>
          <GridItem container alignItems="flex-end" xs={12} md={6}>
            <Card
              color="blank"
              elevation="1"
              width={size.isUpToMedium ? '364px' : '100%'}
              onClick={handleGoTo(routes.comparator)}
            >
              <GridContainer spacing={2}>
                <GridItem xs={2}>
                  <Image src="/assets/images/03-comparador.svg" />
                </GridItem>
                <GridItem xs={10}>
                  <Typography fontSize="16px" fontWeight="bold" lineHeight="18.75px" variant="h4">
                    Comparador de organismos compradores
                  </Typography>
                  <Typography fontSize="13px" lineHeight="15.23px" variant="body1">
                    Conoce la diferencia de las compras realizadas entre distintos organismos.
                  </Typography>
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
        </GridContainer>
      </Content>
    </Root>
  )
}

export default HomeBuyerList
